'use es6';

import FeedbackSubmission from 'customer-data-objects/feedback/FeedbackSubmissionRecord';
import PropTypes from 'prop-types';
const FeedbackSubmissionType = PropTypes.instanceOf(FeedbackSubmission);
export default FeedbackSubmissionType;